import React from 'react';
import { CustomizableQuantity } from './CustomizeWithQuantityModifier';
import { CUSTOMIZE_MODAL_CONSTANTS } from 'organisms/CustomisationModal/Constants/CustomizationModalConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

export const ModalTemplate = props => {
  const {
    addNewProductHandler,
    currencySymbol,
    updateCartHandler,
    customizableFoodItemsList,
    SetCustomizableFoodItemsList,
    totalAmount,
    calculateTotalAmountHandler,
    isEditSelection,
    handleClose,
  } = props;
  const { ADD_NEW_PRODUCT, UPDATE_CART } = CUSTOMIZE_MODAL_CONSTANTS;
  const customizableItemsListLength = Object.keys(customizableFoodItemsList).length;

  return (
    <div>
      {Object.keys(customizableFoodItemsList).map(basketLineItemId => (
        <CustomizableQuantity
          data-testid='ModalTemplate_QuantityModifier'
          addNewProductHandler={addNewProductHandler}
          basketLineItemId={basketLineItemId}
          customizableFoodItemsList={customizableFoodItemsList}
          SetCustomizableFoodItemsList={SetCustomizableFoodItemsList}
          calculateTotalAmountHandler={calculateTotalAmountHandler}
          isEditSelection={isEditSelection}
          handleClose={handleClose}
        />
      ))}
      {isEditSelection ? (
        <div className='editSelectionsItem'>
          <button
            className='button whiteButton blackBorder add-new-product'
            data-testid='add-new-product-for-edit'
            aria-label='Add new product'
            tabindex='0'
            onClick={() => addNewProductHandler()}
          >
            {translateWithI18Next(ADD_NEW_PRODUCT)}
          </button>
        </div>
      ) : (
        <div className={((customizableItemsListLength < 2) && 'FinalButton' ) || 'FinalDivButtons'}>
          <div className='AddNew'>
            <span className='addNewItem' onClick={addNewProductHandler}>
              {translateWithI18Next(ADD_NEW_PRODUCT)}
            </span>
          </div>
          <div className='ButtonAndPopupLink'>
            <button
              disabled={false}
              className='button activeBtn redButton Update-cart-button '
              aria-label='Update Cart'
              tabindex='0'
              onClick={() => updateCartHandler()}
            >
              <span className='TextInButton'>{translateWithI18Next(UPDATE_CART) + ' '}</span>
              <span>{currencySymbol + totalAmount}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
